import { h } from 'vue';
import { RouterView } from 'vue-router';

/** Pass-through layout for nested Vue Router 4 routes (Vue 3: import h, don't use render(h)). */
export default {
  name: 'RouterViewPassThrough',
  render: () => h(RouterView),
};
